<template>
  <div class="AnswerQuestionModal">
    <el-dialog
      title="回答问题"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @open="handleOpen"
      width="30%"
    >
      <el-form ref="form" :rules="rules" :model="formData" size="small">
        <el-form-item label="关联课程:">
          <span>{{ formData.lessonName }}</span>
        </el-form-item>
        <div>提问内容</div>
        <div class="questionBox">
          <el-form-item>
            <span>{{ formData.question }}</span>
          </el-form-item>
          <el-form-item v-if="formData.materialUrls[0]">
            <div class="imageBox">
              <el-image
                style="width: 320px"
                :src="formData.materialUrls[0]"
                :lazy="true"
                object-fit="scale-down"
                :preview-src-list="formData.materialUrls"
                initial-index="0"
              >
              </el-image>
            </div>
          </el-form-item>
          <el-form-item v-if="formData.materialUrls[1]">
            <div class="imageBox">
              <el-image
                style="width: 320px"
                :src="formData.materialUrls[1]"
                :lazy="true"
                object-fit="scale-down"
                :preview-src-list="formData.materialUrls"
                initial-index="1"
              >
              </el-image>
            </div>
          </el-form-item>
        </div>
        <el-form-item label="回答提问" prop="answer">
          <div class="textareaBox">
            <textarea
              :disabled="!isAnswer"
              v-model="formData.answer"
            ></textarea>
          </div>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button type="primary" v-if="isAnswer" @click="handleCommit"
          >提交
        </el-button>
        <el-button type="primary" v-else @click="handleClose">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { answerQuestionMixins } from "@/pages/QuestionManagement/answerQuestionMixins";

export default {
  name: "AnswerQuestionModal",
  mixins: [answerQuestionMixins],
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
    isAnswer: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    visible: {
      get() {
        return this.$store.state.courseCenter.answerQuestionModalVisible;
      },
      set(value) {
        this.$store.commit("courseCenter/setData", {
          key: "answerQuestionModalVisible",
          value,
        });
      },
    },
  },
  methods: {
    ...mapActions("courseCenter", ["saveLessonQuestion"]),
    handleOpen() {
      Object.keys(this.formData).map((key) => {
        this.formData[key] = this.row[key];
      });
    },
    handleClose() {
      this.setData({
        key: "answerQuestionModalVisible",
        value: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.AnswerQuestionModal {
  ::v-deep .el-dialog {
    min-width: 750px;
    height: 750px;
  }

  .lessonNameBox {
    ::v-deep .el-input__inner {
      background-image: none;
      border-radius: 4px;
      border: none;
      box-sizing: border-box;
      color: #606266;
      cursor: default;
    }
  }

  .questionBox {
    padding: 10px 20px;
    background: #efefef;
    margin-top: 10px;
    margin-bottom: 20px;
    min-height: 300px;

    .imageBox {
      width: 320px;
      height: 180px;
      overflow: hidden;
    }
  }

  .textareaBox {
    display: inline-block;
    width: 100%;

    textarea {
      min-height: 120px !important;
      height: auto;
      width: 100%;
      box-sizing: border-box;
      padding: 10px;
      border: 1px solid #dcdfe6 !important;
      resize: none;
      line-height: 1.5;
      font-family: inherit;
      color: #606266;
      font-size: inherit;
    }
  }

  .footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 20px;
  }
}
</style>
